import { IconSvgProps } from "@modules/ui/components/huButtonIcon"

/**
 * Icon in rod wave with two circles
 * https://www.figma.com/design/wLuhUbktTSKgXGiYXFLI0G/Hustleup---Web-23%3A11?node-id=12861-48824&node-type=frame&t=dLXyHq1Wu4uFPy40-0
 * @param props IconSvgProps
 * @returns React.JSX.Element
 */
export const InTransitFailedIcon: React.FC<IconSvgProps> = (props) => (
  <svg
    width={props.size}
    height={props.size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9 19C9 20.6569 7.65685 22 6 22C4.34315 22 3 20.6569 3 19C3 17.3431 4.34315 16 6 16C7.65685 16 9 17.3431 9 19ZM9 19H17.5C17.9 19 18.4 18.9 18.8 18.8M5.2 5.2C4.44952 5.50775 3.82813 6.06854 3.44181 6.78674C3.05549 7.50494 2.92816 8.33607 3.08155 9.13838C3.23493 9.94068 3.65952 10.6645 4.28291 11.1863C4.9063 11.7082 5.68987 11.9957 6.5 12H12M2 2L22 22M21 15.3C20.9521 14.4404 20.5891 13.6285 19.9803 13.0197C19.3715 12.4109 18.5596 12.0479 17.7 12M15 5H10.7M15 5C15 6.65685 16.3431 8 18 8C19.6569 8 21 6.65685 21 5C21 3.34315 19.6569 2 18 2C16.3431 2 15 3.34315 15 5Z"
      stroke={props.color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
